(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .controller('baseController', baseController);

    baseController.$inject = ['$scope', '$location', 'messaging', 'events'];

    function baseController($scope, $location, messaging) {
        $scope.messagingHandles = [];

        $scope.subscribe = function (topic, callback) {
            var handle = messaging.subscribe(topic, callback);

            if (handle) {
                $scope.messagingHandles.push(handle);
            }
        };

        $scope.publish = function (topic, data) {
            messaging.publish(topic, data);
        };

        $scope.$on('$destroy', function () {
            angular.forEach($scope.messagingHandles, function (handle) {
                messaging.unsubscribe(handle);
            });
        });
        $scope.onCancel = function () {
            $location.path('/');
        };
    }
})();
